import React, { PureComponent } from 'react';
import { Query } from 'react-apollo';
import { number, func, bool } from 'prop-types';
import { FETCH_DASHBOARD_DATA } from 'api/dashboard';
import {
  aggregateCropChartData,
  aggregateYieldHistoryChartData,
  aggregateRevenueChartData,
} from './aggregators';
import { connect } from 'react-redux';
import { devLogger } from '../../util/devLogger';

/**
 *
 *
 * @export
 * @param {*} ComposedComponent
 * @returns {React.DOM} - WrappedDashboard (connected component)
 */
export default function dashboardHOC(ComposedComponent) {
  class WrappedDashboard extends PureComponent {
    static displayName = `WrappedDashboard(${ComposedComponent.displayName ||
      ComposedComponent.name ||
      'Component'})`;

    static propTypes = {
      season: number,
      toggleChart: func,
      updatingCropPrices: bool,
    };

    render() {
      const { season, updatingCropPrices } = this.props;

      /* 
        This below handles Chart (Pie, Bar, Line) and RevenueForm request race conditions:
        Check in redux store to see if there is currently a request in progress to update
        crop prices and show the loader if that is the case
      */
      if (updatingCropPrices) {
        devLogger('updatingCropPrices', updatingCropPrices);
        return <ChartLoader />;
      }

      return (
        <Query
          query={FETCH_DASHBOARD_DATA}
          fetchPolicy="cache-and-network"
          variables={{ active: true, season }}
        >
          {({ loading, error, data, refetch }) => {
            if (error) {
              devLogger('dashboardHOC Query Error', { error }, 'log');
              return null;
            }
            if (loading) return <ChartLoader />;

            const chartData = this.aggregateDataForDashboard(data);

            return (
              <ComposedComponent
                {...this.props}
                chartData={chartData}
                refetch={refetch}
              />
            );
          }}
        </Query>
      );
    }

    /**
     *
     *
     * @memberof WrappedDashboard
     * @param {Object} data - data from GraphQL
     * @returns {Object}
     */
    aggregateDataForDashboard = data => {
      return {
        cropChartData: aggregateCropChartData(data.getAllCropsForField),
        yieldChartData: aggregateYieldHistoryChartData(
          data.getAllCropsForField
        ),
        revenueChartData: {
          getAllCropsForField: data.getAllCropsForField,
          getRevenueForecast: aggregateRevenueChartData(
            data.getRevenueForecast
          ),
          rawRevenueData: data.getRevenueForecast,
        },
        storagesData: data.getAllStorages,
        contractsData: data.getAllContracts,
      };
    };
  }

  const mapStateToProps = state => ({
    season: state.settings.season,
    updatingCropPrices: state.settings.updatingCropPrices,
  });

  return connect(mapStateToProps)(WrappedDashboard);
}

/**
 *
 *
 * @function ChartLoader
 * @returns {React.DOM}
 * TODO: create a common component out of this
 */
const ChartLoader = () => {
  return (
    <div
      style={{
        minHeight: '350px',
        textAlign: 'center',
        position: 'relative',
        top: '125px',
      }}
    >
      <h4>Loading ...</h4>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/hoc/dashboard/index.js